import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { useAnyHoverMediaQuery } from "@/react/hooks/useMediaQuery";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { useLayerBlockActions } from "../../Hooks/useLayerBlockActions";

export interface LayersTreeItemMenuProps {
  blockId: string;
}

export const LayersTreeItemMenu = ({ blockId }: LayersTreeItemMenuProps) => {
  const canHover = useAnyHoverMediaQuery();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const options = useLayerBlockActions(blockId);

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- onClick only used to prevent propagation
    <div
      className={classNames({
        "invisible flex items-center group-hover:visible":
          canHover && !isDropdownOpen,
      })}
      onClick={event => {
        event.preventDefault();
        event.stopPropagation();
      }}
    >
      <Dropdown
        onToggle={setIsDropdownOpen}
        direction="right-start"
        className="flex items-center"
        buttonClassName="flex items-center size-5 flex justify-center !rounded-full transition-colors duration-200 hover:bg-tertiary focus-visible:outline-secondary focus-visible:rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:bg-tertiary"
        button={
          <IconButton
            name="20-menu-dots-horizontal"
            iconSize={20}
            buttonSize={28}
            ariaLabel={t("builder_ui.editor.actions")}
          />
        }
        menuWrapperClassName="!mt-0"
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [-24, 16],
              },
            },
          ],
        }}
        options={options}
      />
    </div>
  );
};
